import type * as React from "react";
import { IconClickable, IconClickableType } from "../../../../common/components/icon/IconClickable";
import { IconType } from "../../../../common/components/icon/IconType";
import { type ReactNode } from "react";

interface DeleteButtonProps {
  children?: ReactNode;
  onClick: () => void;
  disabled?: boolean;
}

const DeleteButton: React.FC<DeleteButtonProps> = (props) => {
  return (
    <IconClickable
      clickableType={IconClickableType.PRIMARY}
      onIconClick={props.onClick}
      type={IconType.Bin}
      data-test-id={"btn-delete-line-item"}
      disabled={props.disabled}
    />
  );
};

export default DeleteButton;
